// extracted by mini-css-extract-plugin
export default {"toolbar":"Header_toolbar__mOty3","full_width":"Header_full_width__3I609"};